import { McpKeysGridView } from '~/components/system/mcp-keys';
import { PageContainer } from '~/components/page-container';

export function McpKeys() {
	return (
		<PageContainer>
			<McpKeysGridView />
		</PageContainer>
	);
}
